// extracted by mini-css-extract-plugin
export default {"jobsGrid":"style_jobsGrid__aswnT","addJobBox":"style_addJobBox__zQXBB"};